module.exports = __webpack_public_path__ + "img/lang-club.85f5e9a7.jpg";